import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import {
  IWorksheetComponent,
  WorksheetResultsSection,
  WorksheetsResultsMessagesSection,
} from 'Components/Worksheets/Core';
import { actions } from 'Data/ReduxViewModels/WorksheetEditor';
import { useDispatch, useSelector } from 'react-redux';
import { Chart } from '../../../Shared/Chart';
import { LayerBoundariesGrid } from './LayerBoundariesGrid';
import { LayerBoundariesOptions } from './LayerBoundariesOptions';

let ResultsSectionBase: React.FC<IWorksheetComponent> = ({ createWorksheetSelector, prefixName }) => {
  const dispatch = useDispatch();
  const resultNotObtainable = useSelector(createWorksheetSelector!('Measurements.ResultNotObtainable')) ?? false;
  const results = useSelector(createWorksheetSelector!('Results.LayerBoundaries'));

  const contextCaptions = [{ path: `data.Preparation.ConeDiameterSatisfactory`, caption: 'Preparation' }];

  const updateResults = (value: any[]) => {
    dispatch(
      actions.setValue({
        name: prefixName!('Results.LayerBoundaries'),
        value: value,
        sync: true,
      })
    );
  };

  const createElements = (results: any[], count: number) => {
    return [...results, ...Array(count).fill({})];
  };

  const removeElement = (results: any[], index: number) => {
    var res = [...results];
    res.splice(index, 1);
    return res;
  };

  const handleRemoveRow = (index: number) => {
    updateResults(removeElement(results, index));
  };

  const handleCreateRow = () => {
    updateResults(createElements(results, 1));
  };

  return (
    <WorksheetResultsSection heading="Results">
      {!resultNotObtainable && (
        <NamePrefixModifier appendNamePrefix="Results">
          <Chart />
          <LayerBoundariesOptions />
          <LayerBoundariesGrid results={results} onRemoveRow={handleRemoveRow} onCreateRow={handleCreateRow} />
        </NamePrefixModifier>
      )}
      <ListFieldSection
        visible={resultNotObtainable}
        messages={[{ message: 'Result marked as not obtainable.', severity: 'info' }]}
      />

      {!resultNotObtainable && <WorksheetsResultsMessagesSection contextCaptions={contextCaptions} />}
    </WorksheetResultsSection>
  );
};

const ResultsSection = withInjectedProps(ResultsSectionBase);

export { ResultsSection };
export default ResultsSection;
